import { Injectable } from "@angular/core";
import { ServiceStock } from "./service-stock.service";
import { HttpProviderService } from "./fpx-core";
import { HttpClient } from "@angular/common/http";
import { AppInitService } from "./services/app-init.service";
import { UserService } from "./user.service";
import { CommonService } from "./common.service";
import { PreLoginService } from "./pre-login/pre-login.service";

// const ACTIVITY_TIMEOUT_PERIOD=  100000; //30mins
// const ACTIVITY_TIMEOUT_WARNING_BEFORE= 15000 ; //15 sec
@Injectable({
  providedIn: "root",
})
export class ActivityMonitor {
  private monitorTimeoutHandle: any = null;
  private dismissTimeoutHandle: any = null;
  private displayUserPrompt;
  private dismissUserPrompt;
  private warningTimer: boolean = false;


  private waitForUserActionStartDatetime: number;
  private waitForUserAction: boolean;
  private lastActivityDatetime: number = 0;

  idleTimeout: any;
  idleTimeoutPromptB4Sec: any;

  private activityTimeoutHandle: any = null;
  private logoutProgress: number = 0;

  ACTIVITY_TIMEOUT_PERIOD; //30mins
  ACTIVITY_TIMEOUT_WARNING_BEFORE; //15 sec


  constructor(
    private services: ServiceStock,
    private httpService: HttpProviderService,
    public appInit: AppInitService,
    private httpClient: HttpClient,
    private _userService:UserService,
    public commonService:CommonService,
    private _preLoginService:PreLoginService

  ) {
    this.configData();
  }
  configData() {
    let data = this.appInit.keysValues;
    this.ACTIVITY_TIMEOUT_PERIOD = data.idleTimeoutInMin * 60 * 1000;
    this.ACTIVITY_TIMEOUT_WARNING_BEFORE = data.idleTimeoutPromptB4Sec * 1000;
  }

  startMonitor(displayUserPrompt = () => {}, dismissUserPrompt = () => {}) {
    this.displayUserPrompt = displayUserPrompt;
    this.dismissUserPrompt = dismissUserPrompt;
    // if(this.commonService.getApplicationMode()=='RM'){
    //   document.addEventListener(
    //     "touchstart",
    //     this.doActivityMonitor.bind(this),
    //     false
    //   );
    //   document.addEventListener(
    //     "touchmove",
    //     this.doActivityMonitor.bind(this),
    //     false
    //   );
    //   document.addEventListener(
    //     "touchend",
    //     this.doActivityMonitor.bind(this),
    //     false
    //   );
    //   document.addEventListener(
    //     "keypress",
    //     this.doActivityMonitor.bind(this),
    //     false
    //   );

    //   document.addEventListener(
    //     "mousemove",
    //     this.doActivityMonitor.bind(this),
    //     false
    //   );
    // }
    this.continueAndMonitor();
  }
  public checkAndLogout() {
    if (this._userService.isLoggedIn()) {
      let currentDateTime = new Date().getTime();
      if (this.waitForUserAction) {
        let elapsed = currentDateTime - this.waitForUserActionStartDatetime;
        if (elapsed > this.ACTIVITY_TIMEOUT_WARNING_BEFORE) {
          if (this.dismissTimeoutHandle) {
            clearTimeout(this.dismissTimeoutHandle);
            this.dismissTimeoutHandle = null;
          }
          this.dissmissAndExit();
        }
      } else {
        let elapsed = currentDateTime - this.lastActivityDatetime;
        if (elapsed > this.ACTIVITY_TIMEOUT_PERIOD) {
          this.dissmissAndExit();
        } else if( elapsed > (this.ACTIVITY_TIMEOUT_PERIOD - this.ACTIVITY_TIMEOUT_WARNING_BEFORE)) {
          this.warnAndCheck();
        }
      }
    }
  }

  private warnAndCheck() {
    if (this._userService.isLoggedIn()) {
      let currentDateTime = new Date().getTime();
      let elapsed = currentDateTime - this.lastActivityDatetime;
      if (elapsed > this.ACTIVITY_TIMEOUT_PERIOD) {
        console.log("Activity Timeout Expired");
        this.dissmissAndExit();
      }
       else {
        console.log("Display User Prompt");
        this.dismissTimeoutHandle = setTimeout(() => {
          console.log("Warning Period Elapsed");
          this.dissmissAndExit();
        }, this.ACTIVITY_TIMEOUT_WARNING_BEFORE);
        console.log("Session Exit Warning");

        this.waitForUserAction = true;
        this.waitForUserActionStartDatetime = new Date().getTime();

        this.displayUserPrompt();
      }
    }
    else {
      // this.continueAndMonitor();
    }
  }

  dissmissAndExit() {
    console.log("Session Dismissed");

    this.waitForUserAction = false;

    this.dismissUserPrompt();
  }


  continueSession() {
    console.log("Session Continued");
    this.waitForUserAction = false;
    this._preLoginService.refreshToken();
    this.continueAndMonitor();
  }


  private continueAndMonitor() {

    this.lastActivityDatetime = new Date().getTime();

    this.warningTimer = false;
    if (!this.waitForUserAction) {
      if (this.dismissTimeoutHandle) {
        clearTimeout(this.dismissTimeoutHandle);
        this.dismissTimeoutHandle = null;
        console.log("Cancel Dismiss Timeout Handle");
      }
    }
    if (this.monitorTimeoutHandle) {
      clearTimeout(this.monitorTimeoutHandle);
      // console.log("Activity Reset");
    }
    if (this.activityTimeoutHandle) {
      clearTimeout(this.activityTimeoutHandle);
    }

    // this.activityTimeoutHandle = setTimeout(() => {
    //   this.updateLogoutPeriod();
    // }, 1000);
    if((this.ACTIVITY_TIMEOUT_PERIOD - this.ACTIVITY_TIMEOUT_WARNING_BEFORE) > 0) {
      this.monitorTimeoutHandle = setTimeout(() => {
        this.warnAndCheck();
      }, this.ACTIVITY_TIMEOUT_PERIOD - this.ACTIVITY_TIMEOUT_WARNING_BEFORE);
    }
  }

  private getLogoutProgress() {
    return this.logoutProgress;
  }
  private updateLogoutPeriod() {
    let currentDatetime = new Date().getTime();
    let elapsed = currentDatetime - this.lastActivityDatetime;
    let remaining = this.ACTIVITY_TIMEOUT_PERIOD - elapsed;
    if (remaining > 0) {
      this.logoutProgress = Math.floor(
        (elapsed / this.ACTIVITY_TIMEOUT_PERIOD) * 100
      );
      remaining = Math.floor(remaining / 1000);
      var m: any = Math.floor(remaining / 60);
      var s: any = remaining % 60;

      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      let remainingTime = m + ":" + s;
      if (document.getElementById("logoutTimer")) {
        document.getElementById("logoutTimer").innerHTML = m + ":" + s;
      }
      setTimeout(() => {
        //console.log("Logout Timer Update Triggered");
        this.updateLogoutPeriod();
      }, 1000);
    }
  }

  // private doActivityMonitor() {
  //   // console.log("Activity Detected");
  //   this.continueAndMonitor();
  // }

  updateWarningTime() {
    // console.log("Warning Date And Time Update");
    let currentDatetime = new Date().getTime();
    let elapsed = currentDatetime - this.waitForUserActionStartDatetime;
    let remaining = this.ACTIVITY_TIMEOUT_WARNING_BEFORE - elapsed;
    if (remaining > 0) {
      remaining = Math.floor(remaining / 1000);
      var m: any = Math.floor(remaining / 60);
      var s: any = remaining % 60;

      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      let remainingTime = m + ":" + s;
      try{
        if (document.getElementById("sessionTimer")) {
          document.getElementById("sessionTimer").innerHTML = m + ":" + s;
        }
        // (document.getElementById("sessionTimer"))?.innerHTML = m + ":" + s;
      }
      catch(e){
        console.log(e);
      }
      if (this.waitForUserAction) {
        // console.log("User Prompt Open. Schedule Timer Update",m + ":" + s);
        setTimeout(() => {
          // console.log("Timer Update Triggered");
          this.updateWarningTime();
        }, 1000);
      }
    }
    else {
      console.log("No Warning Time Remaining");
    }
  }



  exitWarningTimer() {}

  stopMonitor() {

    // document.removeEventListener(
    //   "touchstart",
    //   this.doActivityMonitor.bind(this),
    //   false
    // );
    // document.removeEventListener(
    //   "touchmove",
    //   this.doActivityMonitor.bind(this),
    //   false
    // );
    // document.removeEventListener(
    //   "touchend",
    //   this.doActivityMonitor.bind(this),
    //   false
    // );
    // document.removeEventListener(
    //   "keypress",
    //   this.doActivityMonitor.bind(this),
    //   false
    // );
    clearTimeout(this.monitorTimeoutHandle);
    clearTimeout(this.dismissTimeoutHandle);
    this.waitForUserAction=false;

  }
}
